import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, Redirect, useLocation, useHistory } from 'react-router-dom';
import useCheckMobileScreen from '../hooks/useWidth';
import { Login } from '../pages';
import { clearMessage } from '../redux/General/GeneralAction';
import { deleteWorkspace, getPolyclinics } from '../redux/User/UserAction';
import { getAccessToken, getClinicId, getNamespace } from '../utils/storage';
import GuestRoute from './GuestRoute';
import SelectClinic from '../components/Clinics';
import MainRoutes from './MainRoutes';

const Routes = () => {
    const { pathname } = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const isAuth = !!getAccessToken();
    const clinicId = getClinicId();
    const isMobile = useCheckMobileScreen();
    const isSelectClinic = pathname.split('/').filter((item) => item)[0] === 'select-clinic';
    const message = useSelector((state) => state.general?.message);
    const { enqueueSnackbar } = useSnackbar();
    const polyclinics = useSelector((state) => state?.user?.workspace?.polyclinic?.id);
    const namespace = getNamespace();
    const findPolyClinic = polyclinics && polyclinics === namespace;

    const notAccessToClinic = () => {
        dispatch(deleteWorkspace());
        localStorage.removeItem('workspace');
        history.push('/select-clinic');
    };

    useEffect(() => {
        if (message?.status) {
            enqueueSnackbar(message?.text, {
                variant:
                    +message.status >= 200 && +message.status < 300
                        ? 'success'
                        : +message.status < 400 || +message.status === 4401
                        ? 'warning'
                        : 'error',
                autoHideDuration: 3000,
                anchorOrigin:
                    message?.status === 4401
                        ? {
                              vertical: 'bottom',
                              horizontal: 'left'
                          }
                        : {
                              vertical: 'top',
                              horizontal: 'left'
                          }
            });
            dispatch(clearMessage());
        }
    }, [message]);
    useEffect(() => {
        if (isAuth) {
            if (findPolyClinic !== undefined && !findPolyClinic) {
                return notAccessToClinic();
            } else if (clinicId && !isMobile && isSelectClinic) {
                history.replace(`/${clinicId}/patients`);
            }
            if (!clinicId || !polyclinics) {
                const fetch = async () => {
                    const res = await dispatch(getPolyclinics());
                    if (!res?.data?.find((item) => item.id === namespace)) {
                        return notAccessToClinic();
                    }
                };
                fetch();
            }
        } else {
            history.push('/login');
        }
    }, [clinicId, isMobile, isAuth, findPolyClinic, polyclinics]);

    return (
        <>
            <Switch>
                <Route
                    path={isMobile && clinicId ? '/:clinicId/select-clinic' : '/select-clinic'}
                    component={SelectClinic}
                />
                <GuestRoute path="/login" component={Login} />
                <Route path="/" component={MainRoutes} />
                <Redirect from="*" to="/" />
            </Switch>
        </>
    );
};

export default Routes;
